import * as React from 'react';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { Pivot, PivotItem, PivotLinkFormat, PivotLinkSize } from 'office-ui-fabric-react/lib/Pivot';
import { observer } from 'mobx-react';

const styles = require('./DiagnosticsHost.scss');

export interface DiagnosticsHostProps {
    panels: { [name: string]: React.ComponentType<{}> };
    onDismiss?: () => void;
}

export interface DiagnosticsHostState {
    selectedPanel: string;
}

/**
 * The panel which hosts diagnostics information. It has pivots which allow for
 * switching between different diagnostics views. The pivot item names are determined
 *  by the keys of the `panels` prop, with their corresponding views as the values.
 */
@observer
export class DiagnosticsHost extends React.Component<DiagnosticsHostProps, DiagnosticsHostState> {
    constructor(props: DiagnosticsHostProps) {
        super(props);

        let panelNames = Object.keys(this.props.panels);

        this.state = {
            selectedPanel: panelNames.length > 0 ? panelNames[0] : null,
        };
    }

    onSelectPanel = (name: PivotItem) => {
        this.setState({
            selectedPanel: name.props.itemKey,
        });
    };

    render() {
        const { panels, onDismiss } = this.props;
        const pivots = Object.keys(panels).map(name => (
            <PivotItem key={name} headerText={name} itemKey={name} />
        ));
        const SelectedPanel =
            this.state.selectedPanel !== null ? panels[this.state.selectedPanel] : null;

        return (
            <Panel
                className={styles.panel}
                type={PanelType.large}
                isLightDismiss={true}
                isOpen={true}
                isBlocking={false}
                hasCloseButton={true}
                onDismiss={onDismiss}>
                <div className={styles.panelContainer}>
                    <Pivot
                        headersOnly={true}
                        selectedKey={this.state.selectedPanel}
                        onLinkClick={this.onSelectPanel}
                        linkFormat={PivotLinkFormat.tabs}
                        linkSize={PivotLinkSize.large}>
                        {pivots}
                    </Pivot>
                    <div className={styles.panelContent}>
                        <SelectedPanel />
                    </div>
                </div>
            </Panel>
        );
    }
}
